module.exports = __webpack_public_path__ + "img/payment-history.93561a6c.svg";